/**
 * Main layout component
 */

import {Outlet} from 'react-router-dom';
import {Header} from './Header';
import {Sidebar} from './Sidebar';
import {ToastContainer} from '../ui/Toast';

export function Layout() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Header />
      <div className="flex">
        <Sidebar />
        <main className="flex-1 p-6">
          <Outlet />
        </main>
      </div>
      <ToastContainer />
    </div>
  );
}

